import { Item } from "@/utils/types";
import { faGripVertical, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
interface ReorderableListProps<T extends Item> {
  items: T[];
  onReorder: (items: T[]) => void;
  onRemove: (item: T) => void;
  renderItem?: (item: T) => React.ReactNode;
}
const ReorderableList = <T extends Item>({
  items,
  onReorder,
  onRemove,
  renderItem,
}: ReorderableListProps<T>) => {
  const handleDragEnd = (result: any) => {
    if (!result.destination) return;
    const reorderedItems = Array.from(items);
    const [reorderedItem] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, reorderedItem);
    onReorder(reorderedItems);
  };
  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="items">
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className="space-y-2"
          >
            {items.map((item, index) => (
              <Draggable
                key={item.id}
                draggableId={item.id.toString()}
                index={index}
              >
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className="flex items-center justify-between rounded-lg border bg-white p-3 shadow-sm"
                  >
                    <div className="flex items-center gap-3">
                      <FontAwesomeIcon
                        icon={faGripVertical}
                        className="text-gray-400"
                      />
                      {renderItem ? (
                        renderItem(item)
                      ) : (
                        <span className="text-sm">{item.name}</span>
                      )}
                    </div>
                    <button
                      onClick={() => onRemove(item)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
export default ReorderableList;
